import { render, staticRenderFns } from "./PartnersChangeStatusModal.vue?vue&type=template&id=ef7a940c&scoped=true&"
import script from "./PartnersChangeStatusModal.vue?vue&type=script&lang=js&"
export * from "./PartnersChangeStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./PartnersChangeStatusModal.vue?vue&type=style&index=0&id=ef7a940c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7a940c",
  null
  
)

export default component.exports